import { render, staticRenderFns } from "./NavigationBrowser.vue?vue&type=template&id=56d85e58&scoped=true"
import script from "./NavigationBrowser.vue?vue&type=script&lang=js"
export * from "./NavigationBrowser.vue?vue&type=script&lang=js"
import style0 from "./NavigationBrowser.vue?vue&type=style&index=0&id=56d85e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d85e58",
  null
  
)

export default component.exports